import { bestSellers } from "@/mocks/bestSellers";

export default function BestSellers() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 lg:px-8 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            Best Sellers in Kakobuy Spreadsheet
          </h2>
          <p className="text-foreground-600 text-sm mt-3 max-w-xl mx-auto">
            Top-rated products from verified sellers, updated daily with the latest pricing and availability.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {bestSellers.map((item, idx) => (
            <a
              key={idx}
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="group relative block rounded-xl overflow-hidden cursor-pointer"
            >
              <div className="relative w-full aspect-square overflow-hidden rounded-xl">
                <img
                  src={item.image}
                  alt={`${item.name} - Kakobuy Spreadsheet best seller`}
                  title={`${item.name} from ${item.seller}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="font-heading font-bold text-lg md:text-xl text-white">{item.name}</h3>
                  <div className="flex items-center justify-between mt-2">
                    <span className="text-white/80 text-sm">{item.seller}</span>
                    <span className="flex items-center gap-1 text-white text-sm">
                      <i className="ri-star-fill text-accent-500 text-xs"></i>
                      {item.rating}
                    </span>
                  </div>
                  <p className="text-white font-heading font-bold text-xl mt-1">From {item.price}</p>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-background-200">
                <th className="py-3 px-4 text-xs font-label text-foreground-500 uppercase tracking-wider">Product</th>
                <th className="py-3 px-4 text-xs font-label text-foreground-500 uppercase tracking-wider">Seller</th>
                <th className="py-3 px-4 text-xs font-label text-foreground-500 uppercase tracking-wider">Price</th>
                <th className="py-3 px-4 text-xs font-label text-foreground-500 uppercase tracking-wider">Rating</th>
              </tr>
            </thead>
            <tbody>
              {bestSellers.map((item, idx) => (
                <tr key={idx} className="border-b border-background-100 hover:bg-background-100/50 transition-colors">
                  <td className="py-3 px-4">
                    <a
                      href="https://kaspreadsheet.com/"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm font-medium text-foreground-900 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {item.name}
                    </a>
                  </td>
                  <td className="py-3 px-4 text-sm text-foreground-600">{item.seller}</td>
                  <td className="py-3 px-4 text-sm font-semibold text-foreground-900">{item.price}</td>
                  <td className="py-3 px-4 text-sm">
                    <span className="inline-flex items-center gap-1 bg-accent-100 text-accent-900 px-2 py-0.5 rounded-full text-xs font-semibold">
                      <i className="ri-star-fill text-xs"></i>
                      {item.rating}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}